module.exports = __webpack_public_path__ + "static/media/img-thumbnail-grayoundraces@2x.5e122165.png";